<admin-page-simple-content
    [pageError]="pageError"
    [pageStatus]="pageStatus"
    [title]="'Designer: Assets'"
    [icon]="'description'"
>
    <div class="content">
        <div class="header">
            <div class="description">
                <p>
                    This page allows you to update assets that will be available in the designer context.
                    See
                    <a href="https://doc.mediaclip.ca/hub/features/designer-customization/" target="_blank"
                    >documentation</a
                    >
                    for more information.
                </p>
                <p>
                    Please take note that Mediaclip does not support your custom code. By uploading overrides, we cannot
                    guarantee compatibility of your code for all browsers, and even though we try to minimize changes,
                    future Mediaclip Designers versions may break any non-documented hooks and css changes.
                </p>
            </div>
        </div>
        <div class="assets-editor-card mat-elevation-z2">
            @if (pageStatus === "loading") {
                <p>Loading assets...</p>
            } @else {
                @if (!assets || assets.length === 0) {
                    <p class="empty-state">No assets found. Use "Add file" or "Upload files..." to create new assets.</p>
                }
                <admin-assets-editor
                    #assetEditor
                    (uploadAsset)="uploadAsset($event)"
                    (uploadAssets)="uploadAssets($event)"
                    (deleteAsset)="deleteAsset($event)"
                    (customAction)="handleEditorCustomAction($event)"
                    [fileCustomActions]="[{
                        name: 'copy_full_path',
                        label: 'Copy full path',
                        icon: 'content_copy'
                    },
                    {
                        name: 'copy_designer_relative_path',
                        label: 'Copy Designer relative path',
                        icon: 'content_copy'
                    },
                    {
                        name: 'copy_css_relative_path',
                        label: 'Copy CSS relative path',
                        icon: 'content_copy'
                    }]"
                    [assetEditorInformation]="assets"
                    [acceptedUploadFileTypes]="['application/json','application/javascript','text/*','image/*','font/woff2']"
                />
            }
        </div>
        @if (pageStatus === "saveError" && pageError) {
            <admin-error [error]="pageError"></admin-error>
        }
    </div>
</admin-page-simple-content>
